import { render, staticRenderFns } from "./download-center.vue?vue&type=template&id=6325b67e&"
import script from "./download-center.vue?vue&type=script&lang=js&"
export * from "./download-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports